import React from 'react'
import { TableWrapper, Table } from '../common/Table'
import LoadInView from '../common/LoadInView'


interface themaType {
  lv2: string
  lv4: string
  section: string
  simlar_cmpt: string
  similarity: number
}

type propsType = {
    data : any
}

const ThemaResult = (props: propsType) => {

  return (
    <div>
      <h2>검색 결과</h2>
      <LoadInView>
        <TableWrapper>`
          <Table>
            <colgroup>
                <col width="5%"/>
                <col width="10%"/>
                <col width="10%"/>
                <col width="20%"/>
                <col width="35%"/>
                <col width="20%"/>
              </colgroup>
            <thead>
              <tr>
                <th>No.</th>
                <th>계열</th>
                <th>학과</th>
                <th>영역</th>
                <th>유사 항목</th>
                <th>유사도</th>
              </tr>
            </thead>
            <tbody>
              {props.data?.data.map((thema: themaType, index: number) => (
                <tr key={index}>
                  <td key={index}>{index+1}</td>
                  <td key={thema.lv4}>{thema.lv4}</td>
                  <td key={thema.lv4}>{thema.lv4}</td>
                  <td key={thema.section}>{thema.section}</td>
                  <td key={thema.simlar_cmpt}>{thema.simlar_cmpt}</td>
                  <td key={thema.similarity}>{thema.similarity}</td>
                </tr>
                ))
              } 
              </tbody>
            </Table>
        </TableWrapper>
      </LoadInView>
    </div>
  )
}

export default ThemaResult